import React from 'react';
import { FacilityCard } from 'Components/widgets/facility-card/FacilityCard';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  className?: string;
  items: Array<FacilityEntity>;
  title: string;
};
export const Facilities = ({ className, items, title }: Props) => {
  if (!items?.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title className="mb-20" theme="title-brand-n3">
        {title}
      </Title>
      <div className="gap-20 md:columns-2">
        {items.map((facility) => (
          <FacilityCard
            className="mb-40 break-inside-avoid-column"
            facility={facility}
            key={facility.id}
          />
        ))}
      </div>
    </section>
  );
};
